// extracted by mini-css-extract-plugin
export default {"confetti-container":"confettiExplosion_confetti-container__d1vYc","confetti":"confettiExplosion_confetti__NAM8n","confetti-fall":"confettiExplosion_confetti-fall__cgvQ8"};